import type { ComponentType, ReactElement } from "react";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";

interface Props {
  headertitle: string;
  navigation: { goBack: () => void };
  route: { name: string };
  rightComponent?: ReactElement;
}

/** The shared JS header declares every optional prop as required to TS; this narrows it to what these screens use. */
const AttendanceHeader = HeaderWithBackAndTitle as ComponentType<Props>;

export default AttendanceHeader;
